import { type H3Event, getRequestHeader } from 'h3'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { getMarketFromDomain } from '../app/utils/getMarketFromDomain'
import { MARKET_COUNTRY_CODE } from '../constants'

const MARKET_COUNTRY_CODES = new Map(
  Object.values(MarketCountryCode).map((code) => [code.toUpperCase(), code]),
)

function parseMarketCountryCode(value: string): MarketCountryCode | undefined {
  // `value in MarketCountryCode` is false for lowercase (`gb`) because string
  // enums have no reverse mapping. Compare to enum values, case-insensitively.
  for (const token of value.split(',')) {
    const match = MARKET_COUNTRY_CODES.get(token.trim().toUpperCase())
    if (match) return match
  }

  return undefined
}

/** Get market country code from H3 event. */
export function getRequestCountryCode(event: H3Event): MarketCountryCode {
  const header = getRequestHeader(event, MARKET_COUNTRY_CODE)
  const fromHeader = header ? parseMarketCountryCode(header) : undefined

  if (fromHeader) {
    return fromHeader
  }

  // In Nuxt 3.19+, the default forked mode causes the host header to be rewritten
  // to 127.0.0.1:port in development. To test different markets locally, use:
  // `pnpm dev --no-fork` to disable forked mode and preserve the original host header.
  // In production, Cloudflare headers are used, so this is development-only
  // https://github.com/nuxt/cli/issues/1088 same issue as us
  return getMarketFromDomain(event.node.req.headers.host ?? '').countryCode
}
